module.exports = __webpack_public_path__ + "static/media/research-table-1.d4c2f60b.png";